// Sample certification data - you can move this to a separate data file
const CERTIFICATIONS = [
  {
    id: 1,
    title: "Web Design and  Development",
    issuer: "LinkedIn Learning",
    date: "2023",
    verifyLink: "https://drive.google.com/file/d/1bD4QNx0aC7XoKxsSUjFzkUQKNqP1L7Fj/view?usp=sharing",
    credentialId: "AdyfE_E59QqzU4tFdxsjGBgqEbS9",
    skills: ["HTML5", "CSS3", "JavaScript", "Responsive & Mobile-First Design"],
    image: "./assets/images/linkedin_web.png", 
    status: "Verified",
    type: "professional"
  }, 
  {
    id: 2,
    title: "CPP Programming",
    issuer: "IIT Bombay",
    date: "2024",
    verifyLink: "https://drive.google.com/file/d/1gjRT7XKL0l-lrlNwfNyZd_zLtbIH0T7o/view?usp=drive_link",
    credentialId: "40519513ZY",
    skills: ["CPP", "OOPs Concepts", "Data Structures"],
    image: "./assets/images/cpp.jpeg", 
    status: "Verified",
    type: "professional"
  }, 
  {
    id: 3,
    title: "PHP Training",
    issuer: "LinkedIn Learning",
    date: "2023",
    verifyLink: "https://drive.google.com/file/d/1-LKlFrF_Mw5n0996J0C3XevDglgENNCO/view?usp=sharing",
    credentialId: "ARSwdFLUNdd7iiOf0JFl-ONIMg6v",
    skills: ["PHP", "core concepts", "OOPs Concepts"],
    image: "./assets/images/PHP.png",
    status: "Verified",
    type: "professional"
  }, 
    {
    id: 4,
    title: "TCS iON Career Edge - Young Professional Program",
    issuer: "TCS iON",
    date: "2024",
    verifyLink: "https://drive.google.com/file/d/16X6I-npYrwbEAu8n6UDyU60b_NKYOvXQ/view?usp=sharing",
    credentialId: "119854-25695641-1016",
    skills: [" IT Foundational Skills", "Overview of Artificial Intelligence", " Career Guidance Framework"],
    image: "./assets/images/TCS_certificate.png",
    status: "Verified",
    type: "certification"
  }, 
    {
    id: 5,
    title: "JavaScript Training",
    issuer: "EduPyramid [IIT Bombay]",
    date: "2025",
    verifyLink: "https://drive.google.com/file/d/16YS2oVeobRnikI11xrEK4vd-yU2UEtnr/view?usp=sharing",
    credentialId: "4051951PRO",
    skills: ["JavaScript", "Web Development", "Frontend"],
    image: "./assets/images/javascript.jpg",
    status: "Verified",
    type: "professional"
  }, 
   {
    id: 6,
    title: "PHP Stack Training",
    issuer: "Udemy",
    date: "2025",
    verifyLink: "https://drive.google.com/file/d/1NUWGri5B8UXwTSmPqb2Sm-ylq8Vnsbzt/view?usp=sharing",
    credentialId: "UC-ce4df65d-a4a7-40da-988c-60bb5ef7b968",
    skills: ["PHP", "Web Development", "Backend"],
    image: "./assets/images/udemy_php_stack.png",
    status: "Verified",
    type: "professional"
  },
  {
    id: 7,
    title: "Cyber Security Training",
    issuer: "Tech Mahindra Foundation",
    date: "2024",
    verifyLink: "https://drive.google.com/file/d/1QtpDfPixvlKZUuZFHrncSC_AuiwWTlQC/view?usp=sharing",
    credentialId: "UC-ce4df65d-a4a7-40da-988c-60bb5ef7b968",
    skills: ["Cyber Security", "Network Security", "Ethical Hacking"],
    image: "./assets/images/cyber_security_certificate.png",
    status: "Verified",
    type: "professional"
  }
];

export { CERTIFICATIONS };